import React from "react";
import { Grid, Typography } from "@mui/material";
import DetailRow from "../../pages/common-features/DetailRow";
import { useSelector } from "react-redux";
import { RootState } from "../../services/redux/store";

interface ProvideConsentDetailsTabProps {
  partnerDetails: any[];
  partnerApplicationDetails: any[];
  isMobile: boolean;
}

const ProvideConsentDetailsTab: React.FC<ProvideConsentDetailsTabProps> = ({
  partnerDetails,
  partnerApplicationDetails,
  isMobile,
}) => {
  const {
    isMobileVerified: stepperMobileVerified,
    isEmailVerified: stepperEmailVerified,
    formData: stepperFormData,
  } = useSelector((state: RootState) => state.stepper);
  const form = (stepperFormData || {}) as Record<string, unknown>;

  if (!partnerDetails || partnerDetails.length === 0)
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          No details available.
        </Typography>
      </Grid>
    );

  const capitalizeValue = (val: any) => {
    if (val === null || val === undefined) return "";

    return String(val)
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const isStrictVerifiedFlag = (v: unknown): boolean =>
    v === true || v === "true" || v === 1 || v === "1";

  const isMobileVerified =
    isStrictVerifiedFlag(
      partnerDetails?.find(
        (f) => (f.name || "").toLowerCase() === "ismobileverified"
      )?.value
    ) ||
    isStrictVerifiedFlag(stepperMobileVerified) ||
    isStrictVerifiedFlag(form?.mobileNoVerifiedFlag) ||
    isStrictVerifiedFlag(form?.isMobileVerified);

  const isEmailVerified =
    isStrictVerifiedFlag(
      partnerDetails?.find(
        (f) => (f.name || "").toLowerCase() === "isemailverified"
      )?.value
    ) ||
    isStrictVerifiedFlag(stepperEmailVerified) ||
    isStrictVerifiedFlag(form?.emailAddressVerifiedFlag) ||
    isStrictVerifiedFlag(form?.isEmailVerified);

  const productField = partnerApplicationDetails?.find(
    (f) => (f.name || "").toLowerCase() === "product"
  );

  return (
    <>
      {productField && (
        <Grid item xs={12} sm={6} md={3}>
          <DetailRow
            item={{
              label: productField.label,
              value: capitalizeValue(productField.value),
              isVerified: false,
            }}
          />
        </Grid>
      )}
      {partnerDetails?.map((field: any, subIndex: number) => {
        console.log("field", field);
        const skipNames = [
          "applicantid",
          "ismobileverified",
          "isemailverified",
        ];
        if (skipNames.includes((field.name || "").toLowerCase())) return null;

        const fieldNameLower = (field.name || "").toLowerCase();
        let isVerified = false;

        if (fieldNameLower === "phone_number" && isMobileVerified) {
          isVerified = true;
        } else if (fieldNameLower === "email" && isEmailVerified) {
          isVerified = true;
        }

        const rawVal = String(field.value ?? "").trim();
        const showNotVerified =
          (fieldNameLower === "email" && rawVal !== "" && !isEmailVerified) ||
          (fieldNameLower === "phone_number" && rawVal !== "" && !isMobileVerified);

        return (
          <Grid item xs={12} sm={6} md={3} key={subIndex}>
            <DetailRow
              item={{
                label: field.label,
                value: capitalizeValue(field.value),
                isVerified,
                showNotVerified: showNotVerified && !isVerified,
              }}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default ProvideConsentDetailsTab;
